"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const moment = require("moment-timezone");
const react_bootstrap_1 = require("react-bootstrap");
const util_1 = require("util");
const _ = require("lodash");
const constants_1 = require("./constants");
const store_1 = require("./store");
const api_1 = require("./api");
const react_redux_toastr_1 = require("react-redux-toastr");
var DateUtils;
(function (DateUtils) {
    DateUtils.format = (date, format = "h:mmA MM/DD/YYYY") => {
        let timezone = moment.tz.guess();
        const state = store_1.default.getState();
        const user = state.authentication.user;
        if (!util_1.isNullOrUndefined(user)) {
            if (!util_1.isNullOrUndefined(user.timezone)) {
                timezone = user.timezone;
            }
            if (!util_1.isNullOrUndefined(user.dateFormat)) {
                format = user.dateFormat;
            }
        }
        return moment.tz(date, timezone).format(format);
    };
    DateUtils.formatDate = date => {
        let timezone = moment.tz.guess();
        const state = store_1.default.getState();
        const user = state.authentication.user;
        if (!util_1.isNullOrUndefined(user)) {
            if (!util_1.isNullOrUndefined(user.timezone)) {
                timezone = user.timezone;
            }
        }
        return moment.tz(date, timezone).format("L");
    };
    DateUtils.onlyFormat = date => {
        return moment(date).format("L");
    };
    DateUtils.formatTime = date => {
        let timezone = moment.tz.guess();
        const state = store_1.default.getState();
        const user = state.authentication.user;
        if (!util_1.isNullOrUndefined(user)) {
            if (!util_1.isNullOrUndefined(user.timezone)) {
                timezone = user.timezone;
            }
        }
        return moment.tz(date, timezone).format("LT");
    };
    DateUtils.parse = date => {
        let timezone = moment.tz.guess();
        const state = store_1.default.getState();
        const user = state.authentication.user;
        if (!util_1.isNullOrUndefined(user)) {
            if (!util_1.isNullOrUndefined(user.timezone)) {
                timezone = user.timezone;
            }
        }
        return moment.tz(date, timezone).toDate();
    };
})(DateUtils = exports.DateUtils || (exports.DateUtils = {}));
var RouteUtils;
(function (RouteUtils) {
    RouteUtils.set = (pathname, data) => {
        let path = pathname;
        Object.keys(data).forEach(paramName => {
            path = path.replace(":" + paramName, data[paramName]);
        });
        return path;
    };
})(RouteUtils = exports.RouteUtils || (exports.RouteUtils = {}));
var FormUtils;
(function (FormUtils) {
    let helpBlockCount = 0;
    FormUtils.FormFieldStateNone = {
        state: constants_1.ProgressState.None
    };
    FormUtils.formGroupAttributes = (state = null) => {
        const formFieldState = state || FormUtils.FormFieldStateNone;
        switch (formFieldState.state) {
            case constants_1.ProgressState.Success:
                return { validationState: "success" };
            case constants_1.ProgressState.Failed:
                return { validationState: "error" };
            default:
                return {};
        }
    };
    FormUtils.dataChanged = (event, component, forceUpdate = false) => {
        const element = event.target;
        const name = element.name;
        if (element.tagName.toLowerCase() === "input") {
            if (element.type.toLowerCase() === "checkbox") {
                component[name] = element.checked;
            } else {
                component[name] = element.value;
            }
        } else if (element.tagName.toLowerCase() === "textarea" || element.tagName.toLowerCase() === "select") {
            component[name] = element.value;
        }
        if (forceUpdate) component.forceUpdate();
    };
    FormUtils.showErrorBlock = (state = null) => {
        const formFieldState = state || FormUtils.FormFieldStateNone;
        if (formFieldState.state === constants_1.ProgressState.Failed) {
            if (formFieldState.errorMessage instanceof Array) {
                return formFieldState.errorMessage.map(message => {
                    return React.createElement(react_bootstrap_1.HelpBlock, { key: helpBlockCount++, className: "error-help-block" }, message);
                });
            } else {
                return [React.createElement(react_bootstrap_1.HelpBlock, { key: helpBlockCount++, className: "error-help-block" }, formFieldState.errorMessage)];
            }
        }
        return null;
    };
})(FormUtils = exports.FormUtils || (exports.FormUtils = {}));
var SocialUtils;
(function (SocialUtils) {
    SocialUtils.NetworkColor = socialNetwork => {
        switch (socialNetwork.toLocaleLowerCase()) {
            case "facebook":
                return "#6596ff";
            case "instagram":
                return "#f7d84c";
            case "phone":
                return "#62dcae";
            default:
                return "";
        }
    };
})(SocialUtils = exports.SocialUtils || (exports.SocialUtils = {}));
var StringUtils;
(function (StringUtils) {
    StringUtils.capitalizeFirstChar = text => text.charAt(0).toUpperCase() + text.substring(1);
})(StringUtils = exports.StringUtils || (exports.StringUtils = {}));
var PromotionBulkSmsUtils;
(function (PromotionBulkSmsUtils) {
    PromotionBulkSmsUtils.getAllCustomersCount = (data, businessId) => {
        const params = _.pick(data, ['phones', 'customersEndDate', '_group', 'selectedNumberOfUsers', 'sendToAll']);
        return new Promise((resolve, reject) => {
            api_1.doPost(api_1.API.v1.CUSTOMERS.All_PHONES_COUNT(businessId), params).then(res => {
                resolve(res.data.count);
            }).catch(error => {
                reject(error);
            });
        });
    };
})(PromotionBulkSmsUtils = exports.PromotionBulkSmsUtils || (exports.PromotionBulkSmsUtils = {}));
exports.packageValidation = business => {
    const smsCount = business.smsCount;
    const usedSmsCount = business.usedSmsCount;
    if (smsCount && usedSmsCount && new Date(business.packageExpiryDate) > new Date()) {
        let usedSmsPercent = usedSmsCount * 100 / smsCount;
        if (usedSmsPercent >= 75) {
            if (usedSmsCount === smsCount || usedSmsCount > smsCount) {
                react_redux_toastr_1.toastr.error("SMS Count", "You have reached SMS count limit of your subscription plan");
            } else {
                react_redux_toastr_1.toastr.warning("SMS Count", "Your SMS count limit is 25% or less.");
            }
        }
    }
    if (new Date(business.packageExpiryDate) < new Date()) {
        react_redux_toastr_1.toastr.warning("Subscription Expired", "Your current subscription package period has been ended.");
    }
};


//////////////////
// WEBPACK FOOTER
// ./client/src/utils.tsx
// module id = 1055
// module chunks = 0 1 2